export default __webpack_public_path__ + "static/winter40-555beee71ddb411c4fca1ad01204aa40.webp";